export interface ConversionResult {
    html: string;
    warnings: string[];
}

export interface ListContext {
    numId: string;
    level: number;
    format: string;
}

export interface ParagraphProperties {
    listContext: ListContext | null;
    headingLevel: number;
    alignAttr: string;
}

export interface ParagraphResult {
    html: string;
    listContext: ListContext | null;
    isHr: boolean;
}

export interface DroppedContent {
    images: number;
    footnotes: number;
    endnotes: number;
    objects: number;
}

export interface ParserContext {
    rels: Map<string, string>;
    numbering: Map<string, Map<number, string>>;
    headingStyles: Map<string, number>;
    dropped: DroppedContent;
}

// ── HTML Helpers ─────────────────────────────────────────────────────────────

export const escapeHtml = (text: string): string =>
    text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

export function isSafeUrl(url: string): boolean {
    try {
        const parsed = new URL(url, 'https://placeholder.invalid');
        return (
            parsed.protocol === 'http:' ||
            parsed.protocol === 'https:' ||
            parsed.protocol === 'mailto:'
        );
    } catch {
        return false;
    }
}

export function olTypeAttr(format: string): string {
    switch (format) {
        case 'lowerLetter':
            return ' type="a"';
        case 'upperLetter':
            return ' type="A"';
        case 'lowerRoman':
            return ' type="i"';
        case 'upperRoman':
            return ' type="I"';
        default:
            return '';
    }
}

export function isBullet(format: string): boolean {
    return format === 'bullet';
}

export function isToggleOn(el: Element | null): boolean {
    if (!el) return false;
    const val = el.getAttribute('w:val');
    return !val || !val.match(/^(false|0)$/);
}
